import { Link, useNavigate } from "react-router-dom";
import { Feather } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-obsidian/70 border-b border-gold/10">
      <nav className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-link" className="flex items-center gap-2.5 group">
          <span className="grid place-items-center w-9 h-9 rounded-full border border-gold/40 text-gold group-hover:bg-gold/10 transition-colors">
            <Feather className="w-4 h-4" />
          </span>
          <span className="font-serif text-lg tracking-tight text-gold-light">My Last Message</span>
        </Link>
        <div className="flex items-center gap-1 sm:gap-3">
          <Link to="/unlock" data-testid="nav-unlock-link" className="hidden sm:inline-block text-sm text-slate-300 hover:text-gold transition-colors px-3 py-2">
            Unlock a Message
          </Link>
          <Link to="/vault" data-testid="nav-vault-link" className="hidden sm:inline-block text-sm text-slate-300 hover:text-gold transition-colors px-3 py-2">
            My Vault
          </Link>
          <Button
            data-testid="nav-record-button"
            onClick={() => navigate("/record")}
            className="bg-gold hover:bg-gold-hover text-obsidian font-semibold rounded-full px-5"
          >
            Record Message
          </Button>
        </div>
      </nav>
    </header>
  );
};
